import EventsKeywordFilter from './EventsKeywordFilter';
import PrimaryViewToggle from './PrimaryViewToggle';

const Messaging = window.tnew.ui.messaging;

/** @typedef {import('./api/DataStore').default} DataStore */

class EventListingPrimaryView {
  /**
   * @param {*} config
   * @param {EventsKeywordFilter} keywordFilter
   * @param {PrimaryViewToggle} viewToggle
   * @param {DataStore} store
   */
  constructor(config, keywordFilter, viewToggle, store) {
    this.keywordFilter = keywordFilter;
    this.config = config;
    this.isVisible = false;
    this.viewToggle = viewToggle;
    this.store = store;

    this.keywordFilter.on(EventsKeywordFilter.UPDATE, this.onKeywordFilterUpdate.bind(this));

    this.viewToggle.on(PrimaryViewToggle.UPDATE, this.onPrimaryViewModeUpdate.bind(this));
  }

  onPrimaryViewModeUpdate({ mode }) {
    this.isVisible = this.constructor.ViewMode === mode;

    if (this.isVisible) {
      this.fetchData();
    }
  }

  onKeywordFilterUpdate() {
    if (this.isVisible) {
      this.fetchData();
    }
  }

  getSelectedDateFormatted() {
    return this.getCurrentView().getSelectedDateFormatted();
  }

  async fetchData() {
    const view = this.getCurrentView();
    const keywords = this.keywordFilter.getSelectedKeywords();
    const messageCategory = 'event-listing';
    let data;

    Messaging.clear(messageCategory);

    try {
      data = await this.store.fetchData(view.getRangeForSelectedDate(), keywords);
    } catch (exception) {
      Messaging.clear(messageCategory);
      Messaging.addError('An unexpected error has occurred.', true, messageCategory);
      return;
    }

    if (data) {
      view.setData(data);
    } else {
      // console.warn('fetch result ignored');
    }
  }
}

export default EventListingPrimaryView;
